import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Box, Stack } from '@mui/material';

import { PKDOnboardingLayout } from 'components/PKDOnboardingLayout';
import { ReactComponent as EmailLogo } from 'images/email.svg';
import { MainContainer, LogoContainer } from 'pages/ConfirmEmail/styles';
import { PKDFilledButton } from 'components/FilledButton';
import { useGetCurrentParticipantQuery } from 'store/api/pkd/endpoints/user';
import SkeletonLoader from 'pages/ConfirmEmail/skeletonLoader';

import { getPersonMedicalRecords } from 'pages/MedicalInformation/utils';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';

export const Welcome = () => {
  const navigate = useNavigate();
  const { isPersonLoading, person } = useGetPersonAndAttributes();

  const personInfo = {
    ...getPersonMedicalRecords(person?.attributes, {
      hasMigratedMedicalInfo : '',
    }),
  };

  useEffect(() => {
    const hasFullyMigrated = Object.values(personInfo).length === 1;

    if (person && hasFullyMigrated) {
      navigate('/homepage');
    }
  }, [personInfo]);

  return (
    <PKDOnboardingLayout>
      <MainContainer>
        {isPersonLoading
          ? (
            <SkeletonLoader />
          )
          : (
            <Stack
              sx={{ alignItems: 'center' }}>
              <LogoContainer>
                <Box
                  sx={{ margin: '25px 0px 0px 15px' }}>
                  <EmailLogo />
                </Box>
              </LogoContainer>
              <Typography
                textAlign='center'
                sx={{ fontWeight: 'bold', marginTop: 3 }}>
              Welcome!
              </Typography>
              <Typography
                sx={{ marginTop: 2 }} textAlign='center'>
              Hi ADPKD Registry Participant!
                <br />
              Thanks for creating a new log-in to go with our updated Registry
              platform. <br />
              We’ll ask you to verify a few things and then re-sign our consent
              form before being directed to the ADPKD Registry homepage.
                <br />
              If you have any questions about this, email{' '}
                <a
                  href='mailto:registry@pkdcure.org'>registry@pkdcure.org.</a>
              </Typography>
              <Link
                to='/medical-information'>
                <PKDFilledButton
                  sx={{ width: '224px', mt: 5 }}>
                Continue
                </PKDFilledButton>
              </Link>
            </Stack>
          )}
      </MainContainer>
    </PKDOnboardingLayout>
  );
};

export default Welcome;
